import React from "react";
import moment from "moment";

const hoursBuilder = (hours) => {
  if (!hours) return [];
  try {
    const daysArr = [];
    const days = {
      1: "Mon",
      2: "Tue",
      3: "Wed",
      4: "Thu",
      5: "Fri",
      6: "Sat",
      7: "Sun",
    };

    for (const day in days) {
      const currentDay = hours?.[day] ? hours[day] : [];
      const possibleHours = [];
      if (currentDay.length) {
        currentDay.forEach((hours) => {
          const startTime = hours.start_time;
          const endTime = hours.end_time;
          possibleHours.push(
            `${moment(startTime, "HH:mm").format("hh:mm A")} - ${moment(
              endTime,
              "HH:mm"
            ).format("hh:mm A")}`
          );
        });

        daysArr.push({
          day: day,
          status: "Open",
          possibleHours,
        });
      } else {
        daysArr.push({
          day: day,
          status: "Closed",
        });
      }
    }

    const daysObj = {};
    daysArr.forEach((day) => {
      if (!daysObj[`${day.possibleHours || ""}` || day.status]) {
        daysObj[`${day.possibleHours || ""}` || day.status] = [day];
      } else {
        daysObj[`${day.possibleHours || ""}` || day.status].push(day);
      }
    });
    const finalDays = [];

    for (const hours in daysObj) {
      const current = daysObj[hours];
      if (current.length === 1) {
        finalDays.push({
          day: days[current[0].day],
          times: current[0].possibleHours,
          status: current[0].status,
          dow: current[0].day,
        });
      } else {
        // check if the days are consecutive

        const consecutiveDays = [];
        const nonConsecutiveDays = [];

        let temp = [];

        for (let i = 0; i < current.length; i++) {
          if (temp.length === 0) {
            temp.push(current[i]);
          } else {
            if (
              Number(current[i].day) - Number(temp[temp.length - 1].day) ===
              1
            ) {
              temp.push(current[i]);
            } else {
              if (temp.length > 1) {
                consecutiveDays.push(temp);
              } else {
                nonConsecutiveDays.push(temp);
              }
              temp = [];
              temp.push(current[i]);
            }
          }
        }

        if (temp.length > 1) {
          consecutiveDays.push(temp);
        } else {
          nonConsecutiveDays.push(temp);
        }

        if (consecutiveDays.length) {
          consecutiveDays.forEach((day) => {
            finalDays.push({
              day: `${days[day[0].day]} - ${days[day[day.length - 1].day]}`,
              times: day[0].possibleHours || [],
              status: day[0].status,
              dow: day[0].day,
              dowEnd: day[day.length - 1].day,
            });
          });
        }

        if (nonConsecutiveDays.length) {
          nonConsecutiveDays.forEach((day) => {
            finalDays.push({
              day: days[day[0].day],
              times: day[0].possibleHours || [],
              status: day[0].status,
              dow: day[0].day,
            });
          });
        }
      }
    }

    finalDays.sort((a, b) => {
      return Number(a.dow) - Number(b.dow);
    });

    return finalDays;
  } catch (error) {
    return [];
  }
};

const checkFor24Hour = (hours) => {
  if (hours && hours.length === 0) return false;
  if (hours && hours.length === 1 && hours[0] === "12:00 AM - 11:59 PM")
    return true;
  return false;
};

const Hours = (props) => {
  const { hours } = props;
  const hoursArr = hoursBuilder(hours);

  return (
    <div>
      {hoursArr.map((day, index) => {
        return (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: (index + 1) % 2 === 0 ? "#F5F5F5" : "",
              padding: "5px",
            }}
          >
            <h4 variant="h4" style={{ fontSize: "1rem" }}>
              {day?.day}
            </h4>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {day.status === "Open" ? (
                checkFor24Hour(day.times) ? (
                  <div
                    style={{
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                  >
                    24HR
                  </div>
                ) : (
                  day?.times &&
                  day.times.map((hour, index) => {
                    return <div key={index}>{hour}</div>;
                  })
                )
              ) : (
                <div>{day.status}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default Hours;
